import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

// --- Auth token (session_token) : stocké en localStorage + envoyé en Bearer (fallback cookie httpOnly) ---
const TOKEN_KEY = "td_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); };
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// auth endpoints
export const authRegister = (payload) => api.post("/auth/register", payload).then((r) => { setToken(r.data.session_token); return r.data.user; });
export const authLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => { setToken(r.data.session_token); return r.data.user; });
export const authGoogle = (session_id, checkout_session_id) => api.post("/auth/session", { session_id, checkout_session_id }).then((r) => { setToken(r.data.session_token); return r.data.user; });
export const checkAccess = (email) => api.post("/auth/check-access", { email }).then((r) => r.data);
export const deleteMyAccount = () => api.delete("/auth/me").then((r) => r.data);

// ---------------- Paiements (Stripe) ----------------
export const createCheckout = (lookup_key) =>
  api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin }).then((r) => r.data);
export const createOfferCheckout = (offer_key) =>
  api.post("/payments/checkout-offer", { offer_key, origin_url: window.location.origin }).then((r) => r.data);
export const openBillingPortal = () =>
  api.post("/payments/portal", { return_url: window.location.href }).then((r) => r.data);
export const getPaymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data);
export const getPaymentsConfig = () => api.get("/payments/config").then((r) => r.data);
export const setCoachingPrice = (amount_eur) => api.post("/payments/admin/coaching-price", { amount_eur }).then((r) => r.data);

// ---------------- Admin : membres & accès offerts ----------------
export const adminListMembers = () => api.get("/auth/admin/members").then((r) => r.data);
export const adminUpdateMember = (id, p) => api.put(`/auth/admin/members/${id}`, p).then((r) => r.data);
export const adminDeleteMember = (id) => api.delete(`/auth/admin/members/${id}`).then((r) => r.data);
export const adminCreateMember = (p) => api.post("/auth/admin/create-member", p).then((r) => r.data);
export const adminGrantCoaching = (id, delta = 1) => api.post(`/auth/admin/members/${id}/grant-coaching`, { delta }).then((r) => r.data);
export const adminStats = () => api.get("/auth/admin/stats").then((r) => r.data);

// ---------------- Mon Carnet ----------------
export const getCarnet = () => api.get("/carnet").then((r) => r.data);
export const updateCarnetSettings = (p) => api.put("/carnet/settings", p).then((r) => r.data);
export const addCarnetCategory = (payload) => api.post("/carnet/categories", payload).then((r) => r.data);
export const updateCarnetCategory = (id, patch) => api.put(`/carnet/categories/${id}`, patch).then((r) => r.data);
export const reorderCarnetCategories = (ids) => api.post("/carnet/categories/reorder", { ids }).then((r) => r.data);
export const deleteCarnetCategory = (id) => api.delete(`/carnet/categories/${id}`).then((r) => r.data);
export const addCarnetEntry = (p) => api.post("/carnet/entries", p).then((r) => r.data);
export const updateCarnetEntry = (id, p) => api.put(`/carnet/entries/${id}`, p).then((r) => r.data);
export const deleteCarnetEntry = (id) => api.delete(`/carnet/entries/${id}`).then((r) => r.data);
export const reorderCarnetEntries = (ids) => api.post("/carnet/entries/reorder", { ids }).then((r) => r.data);
export const openCarnetFile = (fileId) =>
  api.get(`/carnet/files/${fileId}`, { responseType: "blob" }).then((r) => {
    const url = URL.createObjectURL(r.data);
    window.open(url, "_blank");
  });
export const carnetFileUrl = (fileId) =>
  api.get(`/carnet/files/${fileId}`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data));
export const uploadCarnetFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/carnet/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminListCarnets = () => api.get("/carnet/admin/members").then((r) => r.data);
export const adminListReviews = () => api.get("/carnet/admin/reviews").then((r) => r.data);
export const moveCarnetEntry = (id, section) => api.post(`/carnet/entries/${id}/move`, { section }).then((r) => r.data);
export const replyCarnetEntry = (id, response, attachments = []) => api.post(`/carnet/entries/${id}/reply`, { response, attachments }).then((r) => r.data);

// ---------------- Lexique (dictionnaire) ----------------
export const listLexique = (params = {}) => api.get("/lexique", { params }).then((r) => r.data);
export const lexiqueLetters = () => api.get("/lexique/letters").then((r) => r.data);
export const getLexique = (id) => api.get(`/lexique/${id}`).then((r) => r.data);
export const createLexique = (p) => api.post("/lexique", p).then((r) => r.data);
export const updateLexique = (id, p) => api.put(`/lexique/${id}`, p).then((r) => r.data);
export const deleteLexique = (id) => api.delete(`/lexique/${id}`).then((r) => r.data);
export const regenerateLexiqueTip = (id) => api.post(`/lexique/${id}/regenerate-tip`).then((r) => r.data);
export const getUnseenReply = () => api.get("/carnet/unseen-reply").then((r) => r.data);
export const adminViewCarnet = (userId) => api.get(`/carnet/admin/${userId}`).then((r) => r.data);
export const adminRespondCarnet = (eid, response, attachments = []) => api.post(`/carnet/admin/entries/${eid}/respond`, { response, attachments }).then((r) => r.data);
export const adminMarkReviewSeen = (eid) => api.post(`/carnet/admin/entries/${eid}/seen`).then((r) => r.data);
export const adminCloseReview = (eid, closed = true) => api.post(`/carnet/admin/entries/${eid}/close`, { closed }).then((r) => r.data);
export const markCarnetResponsesSeen = () => api.post("/carnet/responses/seen").then((r) => r.data);
export const getCarnetPending = () => api.get("/carnet/admin/pending-count").then((r) => r.data);
export const adminUnseenReview = () => api.get("/carnet/admin/unseen-review").then((r) => r.data);
// Accès complet au carnet d'un membre
export const requestCarnetAccess = (member_id) => api.post("/carnet/access/request", { member_id }).then((r) => r.data);
export const getCarnetAccessFor = (memberId) => api.get(`/carnet/access/for/${memberId}`).then((r) => r.data);
export const listCarnetAccessGranted = () => api.get("/carnet/access/granted").then((r) => r.data);
export const myCarnetAccessRequests = () => api.get("/carnet/access/requests").then((r) => r.data);
export const carnetAccessPendingCount = () => api.get("/carnet/access/requests/pending-count").then((r) => r.data);
export const respondCarnetAccess = (rid, approve) => api.post(`/carnet/access/${rid}/respond`, { approve }).then((r) => r.data);
export const revokeCarnetAccess = (rid) => api.post(`/carnet/access/${rid}/revoke`).then((r) => r.data);
export const accessAddEntry = (memberId, p) => api.post(`/carnet/access/${memberId}/entries`, p).then((r) => r.data);
export const accessUpdateEntry = (memberId, eid, p) => api.put(`/carnet/access/${memberId}/entries/${eid}`, p).then((r) => r.data);
export const accessDeleteEntry = (memberId, eid) => api.delete(`/carnet/access/${memberId}/entries/${eid}`).then((r) => r.data);
export const accessAddCategory = (memberId, p) => api.post(`/carnet/access/${memberId}/categories`, p).then((r) => r.data);
export const accessUpdateCategory = (memberId, cid, p) => api.put(`/carnet/access/${memberId}/categories/${cid}`, p).then((r) => r.data);
export const accessDeleteCategory = (memberId, cid) => api.delete(`/carnet/access/${memberId}/categories/${cid}`).then((r) => r.data);
export const adminListGrants = () => api.get("/auth/admin/access-grants").then((r) => r.data);
export const adminAddGrants = (emails, type, note) => api.post("/auth/admin/access-grants", { emails, type, note }).then((r) => r.data);
export const adminDeleteGrant = (email) => api.delete(`/auth/admin/access-grants/${encodeURIComponent(email)}`).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then(() => setToken("")).catch(() => setToken(""));

// creations
export const listCreations = (category) =>
  api.get("/creations", { params: category ? { category } : {} }).then((r) => r.data);
export const getCreation = (id) => api.get(`/creations/${id}`).then((r) => r.data);
export const getCreationFull = (id) => api.get(`/creations/${id}`, { params: { media: 1 } }).then((r) => r.data);
export const posterUrl = (id, v) => `${API}/creations/${id}/poster${v ? `?v=${encodeURIComponent(v)}` : ""}`;
export const bgUrl = (id, v) => `${API}/creations/${id}/bg${v ? `?v=${encodeURIComponent(v)}` : ""}`;
export const createCreation = (p) => api.post("/creations", p).then((r) => r.data);
export const updateCreation = (id, p) => api.put(`/creations/${id}`, p).then((r) => r.data);
export const deleteCreation = (id) => api.delete(`/creations/${id}`).then((r) => r.data);
export const uploadAudio = (id, file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post(`/creations/${id}/audio`, fd).then((r) => r.data);
};
export const deleteAudio = (id) => api.delete(`/creations/${id}/audio`).then((r) => r.data);
export const audioUrl = (id) => `${API}/creations/${id}/audio`;

export const uploadReadingAudio = (id, file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post(`/creations/${id}/reading-audio`, fd).then((r) => r.data);
};
export const deleteReadingAudio = (id) => api.delete(`/creations/${id}/reading-audio`).then((r) => r.data);
export const readingAudioUrl = (id) => `${API}/creations/${id}/reading-audio`;

export const uploadChapterAudio = (cid, chid, file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post(`/creations/${cid}/chapters/${chid}/audio`, fd).then((r) => r.data);
};
export const deleteChapterAudio = (cid, chid) => api.delete(`/creations/${cid}/chapters/${chid}/audio`).then((r) => r.data);
export const chapterAudioUrl = (cid, chid) => `${API}/creations/${cid}/chapters/${chid}/audio`;

// inline media assets (images + music cues placed inside chapters)
export const uploadAsset = (cid, file, kind = "image", name = "") => {
  const fd = new FormData(); fd.append("file", file); fd.append("kind", kind); fd.append("name", name || file.name || "media");
  return api.post(`/creations/${cid}/assets`, fd).then((r) => r.data);
};
export const listAssets = (cid) => api.get(`/creations/${cid}/assets`).then((r) => r.data);
export const deleteAsset = (aid) => api.delete(`/assets/${aid}`).then((r) => r.data);
export const assetUrl = (aid) => `${API}/assets/${aid}`;

// categories
export const listCategories = () => api.get("/categories").then((r) => r.data);
export const createCategory = (p) => api.post("/categories", p).then((r) => r.data);
export const updateCategory = (id, p) => api.put(`/categories/${id}`, p).then((r) => r.data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`).then((r) => r.data);

// comments
export const listComments = (cid) => api.get(`/creations/${cid}/comments`).then((r) => r.data);
export const addComment = (p) => api.post("/comments", p).then((r) => r.data);
export const deleteComment = (id) => api.delete(`/comments/${id}`).then((r) => r.data);

// ambiences
export const listAmbiences = () => api.get("/ambiences").then((r) => r.data);
export const createAmbience = (p) => api.post("/ambiences", p).then((r) => r.data);
export const updateAmbience = (id, p) => api.put(`/ambiences/${id}`, p).then((r) => r.data);
export const uploadAmbienceAudio = (id, file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post(`/ambiences/${id}/audio`, fd).then((r) => r.data);
};
export const deleteAmbience = (id) => api.delete(`/ambiences/${id}`).then((r) => r.data);
export const ambienceUrl = (id) => `${API}/ambiences/${id}/audio`;

// subscribers
export const listSubscribers = () => api.get("/subscribers").then((r) => r.data);
export const addSubscriber = (email) => api.post("/subscribers", { email }).then((r) => r.data);
export const deleteSubscriber = (id) => api.delete(`/subscribers/${id}`).then((r) => r.data);

// site settings
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (p) => api.put("/settings", p).then((r) => r.data);

// intro / boot screen
export const uploadIntroVideo = (file) => {
  const fd = new FormData(); fd.append("file", file);
  return api.post("/intro/video", fd).then((r) => r.data);
};
export const deleteIntroVideo = () => api.delete("/intro/video").then((r) => r.data);
export const introVideoUrl = () => `${API}/intro/video`;

// profiles (visitor social profiles)
export const upsertProfile = (p) => api.post("/profiles", p).then((r) => r.data);
export const getProfile = (id) => api.get(`/profiles/${id}`).then((r) => r.data);
export const listProfiles = () => api.get("/profiles").then((r) => r.data);
export const deleteProfile = (id) => api.delete(`/profiles/${id}`).then((r) => r.data);
export const emailStatus = () => api.get("/email/status").then((r) => r.data);

// announcements (creator → visitors)
export const listAnnouncements = () => api.get("/announcements").then((r) => r.data);
export const createAnnouncement = (p) => api.post("/announcements", p).then((r) => r.data);
export const deleteAnnouncement = (id) => api.delete(`/announcements/${id}`).then((r) => r.data);

// ---------------- École (Chemin des 7 Portes) ----------------
export const listFormations = () => api.get("/formations").then((r) => r.data);
export const getFormation = (fid) => api.get(`/formations/${fid}`).then((r) => r.data);
export const getGate = (gid) => api.get(`/gates/${gid}`).then((r) => r.data);
export const getLesson = (lid) => api.get(`/lessons/${lid}`).then((r) => r.data);
export const completeLesson = (lid, body) => api.post(`/lessons/${lid}/complete`, body).then((r) => r.data);
export const getProgress = () => api.get("/progress").then((r) => r.data);
export const listQuestions = (lid) => api.get(`/lessons/${lid}/questions`).then((r) => r.data);
export const addQuestion = (lid, body) => api.post(`/lessons/${lid}/questions`, body).then((r) => r.data);
// admin CRUD école
export const createFormation = (p) => api.post("/formations", p).then((r) => r.data);
export const updateFormation = (id, p) => api.put(`/formations/${id}`, p).then((r) => r.data);
export const deleteFormationApi = (id) => api.delete(`/formations/${id}`).then((r) => r.data);
export const createGate = (p) => api.post("/gates", p).then((r) => r.data);
export const updateGate = (id, p) => api.put(`/gates/${id}`, p).then((r) => r.data);
export const deleteGateApi = (id) => api.delete(`/gates/${id}`).then((r) => r.data);
export const createModule = (p) => api.post("/modules", p).then((r) => r.data);
export const updateModule = (id, p) => api.put(`/modules/${id}`, p).then((r) => r.data);
export const deleteModuleApi = (id) => api.delete(`/modules/${id}`).then((r) => r.data);
export const createLesson = (p) => api.post("/lessons", p).then((r) => r.data);
export const updateLesson = (id, p) => api.put(`/lessons/${id}`, p).then((r) => r.data);
export const deleteLessonApi = (id) => api.delete(`/lessons/${id}`).then((r) => r.data);

// ---------------- Bibliothèque (par Porte) ----------------
export const listBiblio = (porte) => api.get("/biblio", { params: porte ? { porte } : {} }).then((r) => r.data);
export const listBiblioPortes = () => api.get("/biblio/portes").then((r) => r.data);
export const getBiblio = (rid) => api.get(`/biblio/${rid}`).then((r) => r.data);
export const createBiblio = (p) => api.post("/biblio", p).then((r) => r.data);
export const updateBiblio = (rid, p) => api.put(`/biblio/${rid}`, p).then((r) => r.data);
export const deleteBiblio = (rid) => api.delete(`/biblio/${rid}`).then((r) => r.data);
export const getHubConfig = () => api.get("/hub-config").then((r) => r.data);
export const updateHubConfig = (p) => api.put("/hub-config", p).then((r) => r.data);
export const getPageConfig = (key) => api.get(`/page-config/${key}`).then((r) => r.data);
export const updatePageConfig = (key, p) => api.put(`/page-config/${key}`, p).then((r) => r.data);

// ---------------- Nouveautés / Patch Notes ----------------
export const listPatchNotes = () => api.get("/patchnotes").then((r) => r.data);
export const getPatchNote = (id) => api.get(`/patchnotes/${id}`).then((r) => r.data);
export const createPatchNote = (p) => api.post("/patchnotes", p).then((r) => r.data);
export const updatePatchNote = (id, p) => api.put(`/patchnotes/${id}`, p).then((r) => r.data);
export const deletePatchNote = (id) => api.delete(`/patchnotes/${id}`).then((r) => r.data);
export const patchUnreadCount = () => api.get("/patchnotes/unread-count").then((r) => r.data);
export const markPatchesSeen = () => api.post("/patchnotes/mark-seen").then((r) => r.data);
export const patchImageUrl = (id) => `${API}/patchnotes/image/${id}`;
export const uploadPatchImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/patchnotes/upload-image", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};

// ---------------- Profil & Membres ----------------
export const authUpdateProfile = (payload) => api.put("/auth/profile", payload).then((r) => r.data);
export const listMembers = () => api.get("/auth/members").then((r) => r.data);

export const getResume = () => api.get("/resume").then((r) => r.data);
export const recordResume = (lid) => api.post(`/resume/${lid}`).then((r) => r.data);

// ---------------- Partage du Carnet ----------------
export const createShare = (p) => api.post("/carnet/shares", p).then((r) => r.data);
export const listMyShares = () => api.get("/carnet/shares/mine").then((r) => r.data);
export const listSharesWithMe = () => api.get("/carnet/shares/with-me").then((r) => r.data);
export const sharesWithMeCount = () => api.get("/carnet/shares/with-me/count").then((r) => r.data);
export const markSharesSeen = () => api.post("/carnet/shares/with-me/seen").then((r) => r.data);
export const getShare = (id) => api.get(`/carnet/shares/${id}`).then((r) => r.data);
export const getShareByToken = (t) => api.get(`/carnet/shares/link/${t}`).then((r) => r.data);
export const revokeShare = (id) => api.delete(`/carnet/shares/${id}`).then((r) => r.data);
export const commentShare = (id, text) => api.post(`/carnet/shares/${id}/comment`, { text }).then((r) => r.data);
export const editShareEntry = (id, eid, p) => api.put(`/carnet/shares/${id}/entries/${eid}`, p).then((r) => r.data);
